import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { getBoardList } from "crud/search.crud"
import Loading from "pages/Custom/Loading";


const initSearchCondition = {
  username: '',
  subject: '',
  content: ''
}

const DataRoom = () => {

  const selector = useSelector(state => state)
  const history = useHistory()

  const [dataList, setDataList] = useState([]);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id)
  const [isLoading, setIsLoading] = useState(false);
  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [page, setPage] = useState(1)
  const [type, setType] = useState('data')
  const [refresh, setRefresh] = useState(false)
  const [isListEnd, setIsListEnd] = useState(false)
      
  useEffect(() => {
    const scBody = document.getElementById("sc-body");
    if (!scBody) return;
    const handleScroll = () => {
      const scrollPosition = scBody.scrollTop;
      const scrollHeight = scBody.scrollHeight - scBody.clientHeight;
      if (scrollPosition >= scrollHeight - 1) {
        setPage(page + 1)
      }
    }
    scBody.addEventListener('scroll', handleScroll)

    return () => {
      scBody.removeEventListener('scroll', handleScroll)
    }
  }, [dataList])

  const getDataList = async () => {
    if (isLoading || isListEnd)
      return

    setIsLoading(true)
    try {
      const params = {
        username: searchCondition.username,
        subject: searchCondition.subject,
        content: searchCondition.content,
        type : type,
        page: page
      }

      const response = await getBoardList(params);
      if (response.status === 200) {
        const content = response.data.results || []
        const newList = [...dataList, ...content]
        if (page === 1) {
          setDataList(content)
        } else {
          setDataList(newList)
        }
        if (newList.length >= response.data.count) {
          setIsListEnd(true)
        }
      }
      setIsLoading(false)
      setRefresh(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
      setRefresh(false)
    }
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({...prev, [key]: value}))
  }

  const onSearch = async() => {
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
    setIsListEnd(false)
  }
    
  useEffect(() => {
    if (refresh)
      getDataList()
  }, [refresh])
  
  useEffect(() => {
    if (!isListEnd)
      setRefresh(true)
  }, [page, isListEnd])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>자료실 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" breadcrumbItem="자료실" />

          <div className="d-flex w-100 gap-30">
            <div className="email-rightbar mb-3 flex-grow-1">
              <Card>
                <CardBody className="padding-0">
                  <table className="input-table">
                    <tbody>
                      <tr>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">제목</td>
                        <td className="col-20">
                          <input className="is-touched is-dirty av-valid form-control font-size-14 w-80 border-radius-0" placeholder="제목 입력" value={searchCondition.subject} onChange={(e) => {
                            changeSearchCondition('subject', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">내용</td>
                        <td className="col-20">
                          <input className="is-touched is-dirty av-valid form-control font-size-14 w-80 border-radius-0" placeholder="내용 입력" value={searchCondition.content} onChange={(e) => {
                            changeSearchCondition('content', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">작성자</td>
                        <td className="col-20">
                          <input className="is-touched is-dirty av-valid form-control font-size-14 w-80 border-radius-0" placeholder="작성자 입력" value={searchCondition.username} onChange={(e) => {
                            changeSearchCondition('username', e.target.value)
                          }} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </div>
            <div className="d-flex flex-direction-column align-items-end">
              <button style={{width: 143}} type="button" className="custom-btn btn-dark-gradient margin-bottom-8 border-radius-0 white-text border-none margin-right-0 margin-top-6" onClick={() => {
                onSearch()
              }}>
                검색
              </button>
              {/* <button style={{width: 143}} type="button" className="custom-btn border-radius-0 margin-bottom-8 primary-bg white-text button-border margin-right-0" onClick={() => {
                history.push('/data-room-write')
              }}>
                글 작성하기
              </button> */}
            </div>
          </div>

          <Row>
            <Col xs="12">
              <div className="email-rightbar mb-3">

                <Card>
                  <CardBody style={{padding: 0, borderRadius: 4, overflow: 'hidden'}}>
                    <div id={"sc-body"} style={{maxHeight: 660}} className="table-responsive">
                      <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">No</th>
                            <th scope="col">작성자</th>
                            <th scope="col">제목</th>
                            <th scope="col">내용</th>
                            <th scope="col">작성일</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.map((item, index) => {
                            return (
                              <tr className="pointer" key={'data_room_' + index} onClick={() => {
                                history.push(`/data-room-detail/${item.id}`)
                              }}>
                                <td>{item.id}</td>
                                <td>{item.username || ''}</td>
                                <td>{item.subject || ''}</td>
                                <td style={{whiteSpace: "nowrap", maxWidth: 200, textOverflow: 'ellipsis'}}>{item.content || ''}</td>
                                <td>{item.created_at.substr(0, 10)}</td>
                              </tr>
                            )
                          })}
                          {dataList.length === 0 &&
                            <tr>
                              <td scope="row" colSpan="14">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>

                </Card>

              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {isLoading && <Loading />}
    </React.Fragment>
  )
}

export default DataRoom
